export default __webpack_public_path__ + "static/media/img_hourglass.704b44bb.svg";